import { render, staticRenderFns } from "./LatestWeibo.vue?vue&type=template&id=3e147ae3&"
import script from "./LatestWeibo.vue?vue&type=script&lang=js&"
export * from "./LatestWeibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports